var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-container',{staticClass:"text-center"},[_c('img',{staticClass:"kuzzle-logo",attrs:{"src":require("../assets/images/kuzzle-iot.png")}}),_c('h1',[_vm._v("Welcome to Kuzzle IoT Platform")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }